// 保存先を指定しないCSV用

/**
 * 2次元配列からCSVファイルを生成し、ダウンロードを実行
 * @param data CSVのデータ（1行目がヘッダ、2行目以降がデータ）
 * @param filename ダウンロード時のファイル名
 */
export const downloadCSV = (data: string[][], filename: string): void => {
  // セルのエスケープ処理（カンマ、改行、ダブルクォート対策）
  const escapeCell = (cell: string | number | null | undefined): string => {
    if (cell == null) return '""';
    const cellStr = String(cell);
    if (cellStr.includes('"') || cellStr.includes(',') || cellStr.includes('\n')) {
      return `"${cellStr.replace(/"/g, '""')}"`;
    }
    return cellStr;
  };

  // CSV文字列の構築
  const csvContent = data
    .map(row => row.map(escapeCell).join(','))
    .join('\n');

  // Excelでの文字化けを防ぐためのBOM
  const bom = new Uint8Array([0xef, 0xbb, 0xbf]);
  const blob = new Blob([bom, csvContent], { type: 'text/csv;charset=utf-8;' });

  // ダウンロード
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.setAttribute('href', url);
  link.setAttribute('download', filename);

  document.body.appendChild(link);
  link.click();

  // 後処理
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};